module.exports = __webpack_public_path__ + "img/custom-field.06cb49d5.png";